// example data filter list =============>

// [
//   { name: "Applicant", value: "user", type: "checkbox" },
//   { name: "Admin", value: "admin", type: "checkbox" },
// ];

// =======================================>

export const tableFilter = ({
  filterList = [],
  setFilters = () => {},
  onFilterScroll = () => {},
  filterSearch = () => {},
  filterKey = "key",
  filters = {},
  isFilterSearch = false,
  content,
}) => {
  return {
    isFilter: true,
    ...(content
      ? { content }
      : {
          filterData: filterList,
          isFilterSearch: isFilterSearch,
          onFilter: (val) => {
            if (val?.length > 0) {
              setFilters({ [filterKey]: val?.map((item) => item?.value) });
            } else {
              delete filters?.[filterKey];
              setFilters(filters);
            }
          },
          onFilterScroll,
          filterSearch,
        }),
  };
};
